import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-chat-child" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__body" }
const _hoisted_4 = { class: "main__body--list" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "header__account" }
const _hoisted_8 = { class: "main__body--chat" }
const _hoisted_9 = { class: "header" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = { class: "shift" }
const _hoisted_12 = { class: "outgoing" }
const _hoisted_13 = { class: "aside" }

import WidgetPanels from "@/components/widget/WidgetPanels.vue";
import CommonFilter from "@/components/common/CommonFilter.vue";
import CustomChildList from "@/components/custom/CustomChildList.vue";
import {useChatStore} from "@/features/chat/chat.store";
import {onMounted, ref, watch} from "vue";
import {IChat} from "@/features/chat/chat.types";
import WidgetChatPanel from "@/components/widget/WidgetChatPanel.vue";
import {usePersonalStore} from "@/features/personal/personal.store";
import {useRoute} from "vue-router";
import {SearchMd} from "utruckin-icons";
import CustomSearch from "@/components/custom/CustomSearch.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import {IDropdown} from "@/types/main";
import {useAccountStore} from "@/features/account/account.store";
import {IAccount} from "@/features/account/account.types";
import CommonDatepicker from "@/components/common/CommonDatepicker.vue";
import {useShiftStore} from "@/features/shifts/shifts.store";
import {IShift} from "@/features/shifts/shifts.types";
import CustomTab from "@/components/custom/CustomTab.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatChildView',
  setup(__props) {

const route = useRoute();
const chatStore = useChatStore();
const personalStore = usePersonalStore();
const accountStore = useAccountStore()
const shiftStore = useShiftStore()

const chatLoading = ref<boolean>(false);
const chatList = ref<IChat>();
const chatMessageLoading = ref<boolean>(false);
const chatMessages = ref<any>();
const chatTopPageNumber = ref<number>(-1);
const chatBottomPageNumber = ref<number>(-1);
// accounts
const accounts = ref<IDropdown[]>([])
const accountLoading = ref<boolean>(false);
const accountType = ref(0);
// shifts
const shiftLoading = ref<boolean>(false);
const shifts = ref<IDropdown[]>([])
const shiftType = ref(0);
// outgoing
const activeTab = ref<number>(0);
const tabs = [
  {label: "All", value: 0},
  {label: "Sent", value: 1},
  {label: "Received", value: 2},
]

const getChats = async () => {
  chatTopPageNumber.value = route.query.prev_page;
  chatBottomPageNumber.value = route.query.next_page;

  if (route.query.page) {
    chatStore.commonFilter.page = route.query.page;
  }

  if (route.query.page_size) {
    chatStore.commonFilter.page_size = route.query.page_size;
  }

  chatList.value = await chatStore.getChats(chatLoading);
}

const fetchMoreChats = async (type: 'top' | 'bottom') => {
  if (type === 'top') {
    if (chatTopPageNumber.value) {
      chatStore.commonFilter.page = chatTopPageNumber.value;

      const newTopData: IChat = await chatStore.getChats(chatLoading);
      if (newTopData && chatList.value) {
        chatList.value.items = [...newTopData.items, ...chatList.value?.items];
        chatTopPageNumber.value = newTopData.prev_page;
      }
    }
  } else {
    if (chatBottomPageNumber.value) {
      chatStore.commonFilter.page = chatBottomPageNumber.value;

      const newBottomData: IChat = await chatStore.getChats(chatLoading);
      if (newBottomData && chatList.value) {
        chatList.value.items = [...chatList.value?.items, ...newBottomData.items];
        chatBottomPageNumber.value = newBottomData.next_page;
      }
    }
  }
}

const getChatMessages = async () => {
  await personalStore.getPersonalChats(chatMessageLoading, route.params.id, route.query.chat, (res: any) => {
    chatMessages.value = res.data.items;
  });
}

const getAccounts = async () => {
  accounts.value = []

  accountStore.accountsForFilter = await accountStore.getAccounts(accountLoading)

  if (accountStore.accountsForFilter.length) {
    accountStore.accountsForFilter.forEach((item: IAccount) => {
      accounts.value.push({name: item.session_name, value: item.id});
    })

    accounts.value.unshift({name: "All accounts", value: 0});
  }
}

const getShifts = async () => {
  shifts.value = []

  shiftStore.shiftsForFilter = await shiftStore.getShifts(shiftLoading, true)

  if (shiftStore.shiftsForFilter.length) {
    shiftStore.shiftsForFilter.forEach((item: IShift) => {
      shifts.value.push({name: item.title, value: item.id});
    })

    shifts.value.unshift({name: "All shift", value: 0});
  }
}

onMounted(() => {
  getChats();
  getChatMessages();
  getAccounts();
  getShifts()
})

watch(
    () => route.fullPath,
    () => {
      getChatMessages()
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(CustomSearch, {
                width: "100%",
                icon: _unref(SearchMd),
                placeholder: "Users"
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(CommonDropdown, {
                width: "100%",
                label: "Accounts",
                modelValue: accountType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountType).value = $event)),
                items: accounts.value,
                disabled: !accounts.value.length || accountLoading.value 
              }, null, 8, ["modelValue", "items", "disabled"])
            ])
          ]),
          (chatList.value && chatList.value.items && chatList.value.items.length)
            ? (_openBlock(), _createBlock(CustomChildList, {
                key: 0,
                list: chatList.value.items,
                onScroll: fetchMoreChats,
                loading: chatLoading.value
              }, null, 8, ["list", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(CommonDatepicker, {
                mode: "single",
                "default-range": {
            fromDate: new Date(_ctx.yesterday),
            toDate: new Date(_ctx.today),
          },
                "is-two-sinded": true,
                placement: "right",
                clearable: true
              }, null, 8, ["default-range"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(CommonDropdown, {
                modelValue: shiftType.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shiftType).value = $event)),
                label: "All shift",
                items: shifts.value,
                disabled: !shifts.value.length || shiftLoading.value
              }, null, 8, ["modelValue", "items", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(CustomTab, {
                tabs: tabs,
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          (chatMessages.value && chatMessages.value.length)
            ? (_openBlock(), _createBlock(WidgetChatPanel, {
                key: 0,
                messages: chatMessages.value
              }, null, 8, ["messages"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(WidgetPanels, { position: "vertical" })
    ])
  ]))
}
}

})